const MARKUP_CLASSNAMES = {
  socialMedia: 'col--sm12 col--md1',
};

export default MARKUP_CLASSNAMES;
